export enum ClassroomsScopes {
  CAN_VIEW_OWN = 'can_view_own',
  CAN_VIEW_BY_SCHOOL = 'can_view_by_school',
  CAN_UPDATE_OWN = 'can_update_own',
  CAN_UPDATE_BY_SCHOOL = 'can_update_by_school',
  CAN_CREATE = 'can_create',
  CAN_DELETE = 'can_delete',
  CAN_GENERATE_TEMPLATES = 'can_generate_templates',
}
